var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("event-management", {
    attrs: {
      "get-applications": _vm.getApplications,
      "get-categories": _vm.getCategories,
      "get-event": _vm.getEvent,
      "get-roles": _vm.getRoles,
      "save-event": _vm.saveEvent,
      "update-event": _vm.updateEvent
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }